import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { routerMiddleware } from 'connected-react-router';
// import createBrowserHistory from 'history/createBrowserHistory';
import history from './history';
import rootReducer from '../reducers/rootReducer';
import authThunk from '../thunk/authThunk';
// export const history = createBrowserHistory();

const router = routerMiddleware(history);
export function configureStore() {
  let store = createStore(
    rootReducer(history),
    composeWithDevTools(applyMiddleware(thunk.withExtraArgument(authThunk), router))
  );

  if (process.env.NODE_ENV === 'production') {
    store = createStore(rootReducer(history), applyMiddleware(thunk, router));
  }
  return store;
}
